import { ComponentProps } from "react";
import s from "./style.module.scss";
import { clsx } from "clsx";

export const ResizableTextArea = ({
  value,
  className,
  ...rest
}: ComponentProps<"textarea">) => {
  return (
    <div className={clsx(s.textarea, className)}>
      <div className={clsx(s.textareaControl)} data-view="fake">
        {value} <br />
      </div>
      <textarea
        {...rest}
        className={clsx(s.textareaControl)}
        data-view="native"
        value={value}
      />
    </div>
  );
};
